<template>
  <div class="row">
    <div class="col-sm-3" v-for="model in models" :key="model.name">
      <div class="card card-document" :class="{public: model.public}"
           :title="model.public ? 'Público' : 'Privado'"
           @click="findModel(model.name)">
        <div class="card-body text-center">
          <strong>
            {{ model.name }}
          </strong>
          <br>
          <small><strong>API: </strong>{{ model.has_api }}</small>
          <br>
          <small><strong>Pública: </strong>{{ model.public }}</small>
        </div>
      </div>
    </div>

    <hr>

    <Modal v-model="showModal" @close="model = null">
      <div slot="header">
        <h3>{{ model && model.class_name }}</h3>
      </div>
      <div class="event-detail">
        <VueJsonPretty :data='model'
                       :deep='2'
                       :showLength='true'
                       :showLine='true'/>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    components: { Modal, VueJsonPretty },
    created() {
      this.axios.get('models')
        .then(response => this.models = response.data)
    },
    data() {
      return {
        model: null,
        models: [],
        showModal: false
      }
    },
    methods: {
      findModel(name) {
        this.axios.get(`models/${name}`)
          .then(response => this.model = response.data)
          .then(() => this.showModal = true)
      }
    },
    name: 'Models'
  }
</script>

<style scoped>

  .event-detail * {
    background: #051724;
    color: #FFF;
    padding: 16px;
    border-radius: 8px;
  }

  .public {
    background: #d7e7d7;
  }

  .card {
    cursor: pointer;
  }

</style>